module.exports = __webpack_public_path__ + "assets/img/unkown_icon.34e8e80e.svg";